import React from 'react';
import ciaodarLogo from '../../images/ciaodarlogotransp.png';

const IconLogo = () => (
  <img
    src={ciaodarLogo}
    alt="Logo"
    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
  />
);

export default IconLogo;
